"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Alert(props) {
  return /*#__PURE__*/_react.default.createElement(_Alert.default, _extends({
    elevation: 6,
    variant: "filled"
  }, props));
}

var Notification = function Notification(_ref) {
  var openAlert = _ref.openAlert,
      onCloseAlert = _ref.onCloseAlert,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "success" : _ref$type,
      message = _ref.message;
  return /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    open: openAlert,
    autoHideDuration: 6000,
    onClose: onCloseAlert
  }, /*#__PURE__*/_react.default.createElement(Alert, {
    onClose: onCloseAlert,
    severity: type
  }, message));
};

Notification.propTypes = {
  openAlert: _propTypes.default.bool,
  onCloseAlert: _propTypes.default.func
};
Notification.defaultProps = {
  type: "success",
  message: "Formulario guardado exitosamente"
};
var _default = Notification;
exports.default = _default;